<template>
    <div class="ur-data-grid__info-item ur-data-grid__action__button-area">
        <template v-if="onCreate">
            <!-- [BTN] Case-01. On creating -->
            <ur-button small @click="btnCreate" main>{{msgSave}}</ur-button>
            <ur-button small @click="btnCancel">{{msgCancel}}</ur-button>
        </template>
        <template v-else-if="onEdit">
            <!-- [BTN] Case-02. On editing -->
            <ur-button small @click="btnSave" main>{{msgSave}}</ur-button>
            <ur-button small @click="btnCancel">{{msgCancel}}</ur-button>
        </template>
        <template v-else>
            <!-- [BTN] Case-03. Elses -->
            <ur-button small @click="btnAdd" v-if="gridInfo.opts.authCreate">{{msgAdd}}</ur-button>
            <ur-button small @click="btnDel" v-if="gridInfo.opts.authRemove" :disabled="selCnt===0">{{msgDel}}</ur-button>
            <ur-button small @click="btnMod" v-if="gridInfo.opts.authUpdate" :disabled="!onSingleSelected" >{{msgMod}}</ur-button>
        </template>
    </div>
</template>

<script>
import {CONST} from '../../config'
export default {
    name : "urDataGridInfoModuleRowActButton",
    inject : ['gridInfo'],
    computed : {
        // [COMPUTED] Values
        selCnt()       {return this.gridInfo.vars_selLen},
        // [COMPUTED] flags
        onSingleSelected()      {return this.gridInfo.vars_selLen === 1},
        onCreate()     {return !!this.gridInfo.vars_currEditRow &&  this.gridInfo.vars_onCreating},
        onEdit()       {return !!this.gridInfo.vars_currEditRow},
        // [COMPUTED] messages
        msgAdd()   {return this.gridInfo.opts.msgBtnAdd},
        msgDel()   {return this.gridInfo.opts.msgBtnDelete},
        msgMod()   {return this.gridInfo.opts.msgBtnModify},
        msgSave()  {return this.gridInfo.opts.msgBtnSave},
        msgCancel(){return this.gridInfo.opts.msgBtnCancel}
    },
    methods : {
        // [METHODS] btnAdd : Make temp row to add new Item
        btnAdd() {
            this.gridInfo.func.addEmptyRow();
        },
        // [METHODS] btnCreate : End creating new item & save to origin data.
        btnCreate() {
            var row = this.gridInfo.vars_currEditRow;
            this.gridInfo.func.createNewRow(row);
        },
        // [METHODS] btnDel : Remove selected data
        btnDel() {
            var rows = this.gridInfo.sels;
            const BD = this.gridInfo.opts.blockDelete;
            if(BD) {
                const FLAG = CONST.VAL.DIRTY.FLAG.CREATE;
                const nRows = rows.filter(row => {
                    if(typeof BD === 'function') {
                        return BD(row);
                    } else {
                        return row.__dirty === FLAG
                    }
                });
                if(nRows.length !== rows.length && nRows.length === 0) {
                    console.warn('[UIDev] blockDelete option is activate. Cannot remove rows.')
                }
                this.gridInfo.func.removeRows(nRows);
            } else {
                this.gridInfo.func.removeRows(rows);
            }
        },
        // [METHODS] btnMod : Toggle row to modifying the item
        btnMod() {
            // 1. Modifying can enable only one item is selected. pick first = sels[0]
            //var row = this.gridInfo.sels[0];
            // var row = this.gridInfo.focusRow;
            let row = this.gridInfo.sels[0];
            if(!row) return;
            // 2. toggle row edit mode.
            this.gridInfo.func.toggleRowModify(row);
        },
        btnSave() {
            // 1. toggle row edit mode & save it.
            var row = this.gridInfo.vars_currEditRow;
            this.gridInfo.func.toggleRowSaved(row);
        },
        btnCancel() {
            this.gridInfo.func.toggleEditCancel();
        }
    }
}

</script>